export function padStart(v: number, length: number = 2, padString: string = '0') {
  return v?.toString().padStart(length, padString);
}
